module.exports = __webpack_public_path__ + "static/media/at.af0b472e.svg";